import * as React from 'react'

import { IItemCard } from '../interface'
import { filterAttributes, formattedLabel, formattedValue } from './utils'

import * as styles from './lockupAttributes.module.css'

const LockupAttributes = ({ item }: IItemCard) => {
  const { attributes } = item

  if (!attributes.length) {
    return null
  }

  return (
    <ul>
      {filterAttributes(attributes).map((attribute, index): any => (
        <li className={styles.attribute} key={index}>
          <span className={styles.label}>{formattedLabel(attribute)}: </span>
          <span className={styles.value}>{formattedValue(attribute)}</span>
        </li>
      ))}
    </ul>
  )
}

export default LockupAttributes
